import { Box, styled, Typography, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { createAssemblyCategory } from 'src/services/assembly-category';
import { handleApiError } from 'src/utils/api.utils';

type AddCategoryProps = {
  onSuccess: () => void;
};

export const AddCategory = ({ onSuccess }: AddCategoryProps) => {
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error('Le nom est requis');
      return;
    }

    setIsSubmitting(true);
    try {
      await createAssemblyCategory(name.trim());
      toast.success('Catégorie créée avec succès');
      setName('');
      onSuccess();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Ajouter une catégorie
      </Typography>

      <Form onSubmit={handleSubmit}>
        <TextField
          label="Nom de la catégorie"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
        />

        <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
          {isSubmitting ? 'Création...' : 'Créer'}
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '20px',
});

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  maxWidth: '400px',
});
